import React, {FC} from 'react';

import {ArrowDown, Icon} from '@optimaxdev/icons';
import classNames from 'classnames';

import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {CartItemInfo} from '../cartItemInfo/cartItemInfo';
import {CartItemPriceConnected} from '../cartItemPrice/cartItemPrice';

import s from './cartItemPreview.scss';

export type CartItemPreviewType = {
    item: CheckoutItemType;
    isShowDetails: boolean;
    togglePrescriptionDetails: () => void;
    isOpen: boolean;
};

/**
 * Preview Cart Item
 */
export const CartItemPreview: FC<CartItemPreviewType> = ({
    isOpen,
    isShowDetails,
    item,
    togglePrescriptionDetails,
}) => {
    return (
        <div className={s.productWrapper}>
            <CartItemPriceConnected id={item.id} />
            <h2 className={s.title}>{item.windowName}</h2>
            <CartItemInfo item={item} />
            {isShowDetails && (
                <button className={s.button} onClick={togglePrescriptionDetails} type="button">
                    Prescription & Details
                    <span
                        className={classNames(s.arrow, {[s.arrowAnimate]: isOpen})}
                        role="presentation"
                    >
                        <Icon className={s.icon} icon={ArrowDown} />
                    </span>
                </button>
            )}
        </div>
    );
};
